import React from 'react'
import { Switch, Route } from "react-router-dom"
import { Row, Col } from 'antd'
import logo from "../assets/images/logo.png"

import Login from "../page/Auth/Login"
import Signup from "../page/Auth/Signup"
import ChangePass from "../page/Auth/ChangePass"
import ForgotPass from "../page/Auth/ForgotPass"
import ResetPass from "../page/Auth/ResetPass"

const AuthLayout = () => {

  return (
    <Row justify="center" align="middle" className="auth-container">
      <Col span={24}>
        <Row justify="center">
          <Col span={24} className="logo-container">
            <img src={logo} alt="" className="auth-logo" />
          </Col>
          <Col span={24}>
            <Switch>
              <Route exact path="/auth/login" component={Login} />
              <Route exact path="/auth/signup" component={Signup} />
              <Route exact path="/auth/change-pass" component={ChangePass} />
              <Route exact path="/auth/forgot" component={ForgotPass} />
              <Route exact path="/auth/reset" component={ResetPass} />
            </Switch>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default AuthLayout
